var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum4Gray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7773,
    cy: 16.5742,
    r: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8208 18.0142H17.4158V15.7492C17.4158 15.1042 17.4608 14.0992 17.4908 13.4392H17.4308C17.1608 14.0392 16.8608 14.6542 16.5458 15.2542L14.8208 18.0142ZM17.4158 22.5742V19.6942H12.6758V18.1942L16.8158 11.4592H19.4708V18.0142H20.7758V19.6942H19.4708V22.5742H17.4158Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum4Gray);
export default __webpack_public_path__ + "static/media/icon_circleNum_4_gray.cb385ac5c7bd8e0c29bab6ce63030cfc.svg";
export { ForwardRef as ReactComponent };